<template>
  <el-card>

    <el-row>
      <el-col :span="12">
        <el-form ref="dataForm" :model="dataForm" :rules="rules">
          <el-form-item label="险种名称" prop="type_name">
            <el-input v-model="dataForm.type_name" placeholder="请输入险种名称" :disabled="isDisable"></el-input>
          </el-form-item>
          <el-form-item label="险种类型代码" prop="insurance_type_code">
            <el-input v-model="dataForm.insurance_type_code" placeholder="请输入险种类型代码" :disabled="isDisable"></el-input>
          </el-form-item>
          <el-form-item label="是否团体险" prop="is_group_insurance">
            <el-radio-group v-model="dataForm.is_group_insurance">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="dataForm.remark" :rows="5" placeholder="" type="textarea" :disabled="isDisable"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="12"></el-col>
    </el-row>

    <el-row>
      <el-col>
        <el-button @click="goBack">取消</el-button>
        <el-button @click="reset" v-if="pageAction ==='action.edit'">重置</el-button>
        <el-button type="primary" @click="save" v-if="pageAction === 'action.add' || pageAction ==='action.edit'">保存</el-button>
        <el-button type="primary" @click="saveAndAdd" v-if="pageAction === 'action.add'">保存并继续添加</el-button>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import { fetchSettingInsuranceType } from '@/api/billing'
import { createSettingInsuranceType } from '@/api/billing'
import { updateSettingInsuranceType } from '@/api/billing'
export default {
  name:'setting-insurance-type',
  data(){
    return{
      dataForm:{
        type_name: '',
        insurance_type_code: '',
        is_group_insurance: null,
        remark: '',
        company: null,
      },
      tempDataForm:{},
      rules: {
        type_name: [
          {required: true, message: '请输入险种名称', trigger: 'blur'}
        ],
        is_group_insurance: [
          {required: true, message: '请选择是否团体险', trigger: 'blur'}
        ]
      },
      company_id: 0,
      id: 0,
      pageAction: '',
      isDisable: false,
    }
  },
  methods:{
    clearDataForm: function(){
      this.dataForm.type_name = ''
      this.dataForm.insurance_type_code = ''
      this.dataForm.is_group_insurance = null
      this.dataForm.remark = ''
    },
    goBack: function(){
      this.$router.go(-1)
    },
    reset: function(){
      this.dataForm = Object.assign({}, this.tempDataForm)
    },
    save: function(){
      if (this.pageAction === 'action.add'){
        this.createData(this.goBack)
      } else if (this.pageAction === 'action.edit'){
        this.updateData(null)
      }
    },
    saveAndAdd: function(){
      if (this.pageAction === 'action.add'){
        this.createData(this.clearDataForm)
      }
    },
    showAddView: function(){
      console.log('showAddView()')
      this.pageAction = 'action.add'
      this.isDisable = false
    },
    showView: function(){
      console.log('showView()')
      this.pageAction = 'action.view'
      this.isDisable = true
      this.getData()
    },
    showEditView: function(){
      console.log('showEditView()')
      this.pageAction = 'action.edit'
      this.isDisable = false
      this.getData()
    },
    getData: function(){
      fetchSettingInsuranceType(this.id)
        .then(resp=>{
          this.dataForm.type_name = resp.type_name
          this.dataForm.insurance_type_code = resp.insurance_type_code
          this.dataForm.is_group_insurance = resp.is_group_insurance
          this.dataForm.remark = resp.remark
          this.dataForm.company = resp.company
          console.log(this.dataForm)
          this.tempDataForm = Object.assign({}, this.dataForm)
        }).catch(err=>{
          this.$error_message(err)
        })
    },
    createData: function(callBack){
      this.$refs.dataForm.validate(valid=>{
        if(valid){
          this.dataForm.company = this.company_id
          this.dataForm.branch_office = this.branch_office_id
          createSettingInsuranceType(this.dataForm, this.company_id)
            .then(resp=>{
              this.$message.success('保存险种信息成功')
              if (typeof callBack == 'function'){
                callBack()
              }
            }).catch(err=>{
              this.$error_message(err)
            })
        }
      })
    },
    updateData: function(callBack){
      this.$refs.dataForm.validate(valid=>{
        if(valid){
          updateSettingInsuranceType(this.dataForm, this.id)
            .then(resp=>{
              this.$message.success('更新险种信息成功')
              this.tempDataForm = Object.assign({}, this.dataForm)
              if (typeof callBack == 'function'){
                callBack()
              }
            }).catch(err=>{
              this.$error_message(err)
            })
        }
      })
    }
  },
  created(){
    if (this.$route.query.company_id === undefined || this.$route.query.company_id === null){
      console.log('missing company_id')
      this.$router.push('/404')
    }
    this.company_id = this.$route.query.company_id

    if (this.$route.query.branch_office_id === undefined || this.$route.query.branch_office_id === null){
      console.log('missing branch_office_id')
      this.$router.push('/404')
    }
    this.branch_office_id = this.$route.query.branch_office_id

    if (this.$route.name === 'addSettingInsuranceType') {
      if (!this.$perm(['billing.create_setting_insurance_type'])){
        this.$router.push('/401')
      }
      this.showAddView()
      return
    }

    if (this.$route.query.id === undefined || this.$route.query.id === null){
      this.$router.push('/404')
    }
    this.id = this.$route.query.id

    if (this.$route.name === 'viewSettingInsuranceType') {
      if (!this.$perm(['billing.view_setting_insurance_type'])){
        this.$router.push('/401')
      }
      this.showView()
      return
    }

    if (this.$route.name === 'editSettingInsuranceType') {
      if (!this.$perm(['billing.update_setting_insurance_type'])){
        this.$router.push('/401')
      }
      this.showEditView()
      return
    }

    this.$router.push('/404')
  }
}
</script>